
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 0h14v14H0z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"fill":"#33373D","fill-rule":"nonzero","d":"M6.708 0a6.709 6.709 0 015.323 10.792l2.004 2.006-1.237 1.237-2.006-2.004A6.709 6.709 0 116.708 0zm0 1.75a4.958 4.958 0 100 9.917 4.958 4.958 0 000-9.917z","mask":"url(#b)"}})])])
          )
        }
      }
    